import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

import { Button } from "@aviary";
import { l } from "@shared/locales/i18n";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";

import * as styles from "./ViewAll.styles";

interface Props {
  onClick: () => void;
  isHighlighted: boolean;
}

const ViewAll = ({ onClick, isHighlighted }: Props) => {
  const { t } = useTranslation();

  const buttonStyles = [styles.container, isHighlighted ? styles.highlightRow : undefined];

  return (
    <Button isText isColor="info" css={buttonStyles} onClick={onClick}>
      <span css={styles.text}>{t(l.sharedCatalog.typeahead.Enter)}</span>
      <FontAwesomeIcon css={styles.arrow} icon={faChevronRight} aria-hidden />
    </Button>
  );
};

export { ViewAll };
